import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      "A project's generated engagement charter. Generation does not currently persist a record, but this exists so one can be stored when it does.",
    name: 'Engagement Charters',
    partialId: PartialId.Standard.create('engagement_charters'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
